"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _audioVideoDidStopHandler = require("./audioVideoDidStopHandler");
Object.keys(_audioVideoDidStopHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _audioVideoDidStopHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _audioVideoDidStopHandler[key];
    }
  });
});